import type { TransportRequestConfig } from "@/infrastructure/http/transport-policy";

export interface RecordsMetaBatchRequestOptions {
  include?: string[];
  signal?: AbortSignal;
  transportConfig?: TransportRequestConfig;
  mode?: "full" | "summary";
  batchSize?: number;
}

export const BACKGROUND_METADATA_TRANSPORT_CONFIG: TransportRequestConfig = {
  timeoutMs: 10_000,
  maxAttempts: 1,
};

export const NAVIGATION_REQUEST_SCOPE = "records-navigation";
export const RECORDS_TABLE_META_NAMESPACE = "records-table-meta";
export const NAVBAR_RECORDS_NAMESPACE = "navbar-records";
export const NAVBAR_META_NAMESPACE = "navbar-meta";

export const DEFAULT_RECORDS_META_BATCH_SIZE = 10;
